import CryptoJS from "crypto-js";

const adminRoles = ['admin', 'mod-admin', 'super-admin'];

export function limit(text, length) {
  if (text?.length > length) {
    return text.substring(0, length) + "...";
  }
  return text;
}

export const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

export function defaultImageProduct(e) {
  e.target.src =
    "https://files.digitalpower.ar/download/papelera.db/default-product.png";
}

const SECRET_KEY = "VIVAN_LAS_TETAS";
export function encrypt(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
}

export function decrypt(ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  try {
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    return null; // O maneja el error como prefieras
  }
}

export function isAdmin (user) {
  if (adminRoles.includes(user.role)) return true;
  return false;
}